import React from 'react'
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import Busqueda  from './busqueda';

const Headers = ({usuario}) => {
    const cookiees = new Cookies();

    function refreshPage(){ window.location.reload(); } 



   


return (

    
    <nav className="navbar navbar-expand-lg navbar-light bg-light"  >
            <div className="container">
                <Link to={'/'} className="btn btn-link">
                   Iniciar Sesion
                </Link>
                <Link to={'/'} className="btn btn-link">
                    Cerrar Sesion
                </Link>
                <a className="nav-link"><b> Usuario:  </b></a> 
            
                
               
            </div>
        </nav>
      
    
  );
};
 
export default Headers;